export const RESTART_ON_REMOUNT = "@@saga-injector/restart-on-remount"
export const DAEMON = "@@saga-injector/daemon"
export const ONCE_TILL_UNMOUNT = "@@saga-injector/once-till-unmount"
export const ROLES_ADMIN = [1, 2, 3, 4]
export const ROLES_ADMIN_MANDU = [3, 4]
export const ROLE_COMPANY_SUPER_ADMIN = 1
export const ROLE_COMPANY_ADMIN = 2
export const ROLE_MANDU_SUPER_ADMIN = 3
export const ROLE_MANDU_ADMIN = 4
export const ROLE_AMBASSADOR = 5
export const ROLE_LEADER = 6
export const ROLE_SUPPORT = 7
export const IDLE_TIME = 15 // Minutes
export const SAVING_LOG_TIME = 2 // Minutes
export const ACTIVE = 1
export const INACTIVE = 0
export const TYPE_FETCHING = {
  post: "POST",
  get: "GET",
  put: "PUT",
  delete: "DELETE",
}
export const CODE_FETCHING = {
  success: {
    ok: 200,
    created: 201,
    accepted: 202,
  },
  error: {
    unknownUrl: 404,
    denieded: 429,
    Unauthorized: 401,
    UnprocessableEntity: 422,
  },
}
export const MEASURE_STATUS = {
  draft: {
    id_measure_status: 1,
    name: "Borrador",
    slug: "borrador",
  },
  pending: {
    id_measure_status: 2,
    name: "Pendiente",
    slug: "pendiente",
  },
  in_progress: {
    id_measure_status: 3,
    name: "En curso",
    slug: "en-curso",
  },
  finished: {
    id_measure_status: 4,
    name: "Finalizada",
    slug: "finalizada",
  },
  closed: {
    id_measure_status: 5,
    name: "Cerrada",
    slug: "cerrada",
  },
}
export const WORKING_ENVIRONMENT_LABEL = "Clima Laboral"
export const ORGANIZATION = "organization"
export const DIVISIONS = "divisions"
export const EMPLOYEES = "employees"
export const QUESTIONNAIRES = "questionnaires"
export const SURVEYS = "surveys"
export const MEASURES = "measures"
export const REPORTS = "reports"
export const OVERALL_RESULTS = "overall-results"
export const RESULT_BY_DIMENSION = "result-by-dimension"
export const RESULT_BY_DIVISION = "result-by-division"
export const RESULT_BY_TEAM = "result-by-team"
export const COMPARATIVE_ANALYSIS = "comparative-analysis"
export const COMPARATIVE_ANALYSIS_TEAM = "comparative-analysis-team"
export const QUALITATIVE_FEEDBACK = "qualitative-feedback"
export const WORD_CLOUD = "word-cloud"
export const IMPACT_ANALYSIS = "impact-analysis"
export const HISTORICAL_ANALYSIS = "historical-analysis"
export const EXPORTABLES = "exportables"
export const TRACING = "tracing"
export const ACTION_PLANS = "action-plans"
export const RECOMMENDATIONS = "recommendations"
export const CONTROL_PANEL = "control-panel"
export const SYNCHRONIZATION_ERRORS = "synchronization-errors"
export const ADMINISTRATOR_USERS = "administrator-users"
export const LEADER_USERS = "leader-users"
export const AMBASSADOR_USERS = "ambassador-users"
export const EMAILS_AND_NOTIFICATIONS = "emails-and-notifications"
export const DASHBOARD = "dashboard"
export const BENCHMARK = "benchmark"
export const ENABLE = "enable"
export const DISABLE = "disable"
export const PROMO = "promo"
export const QUESTION_PONDERATED = "question-ponderated"
export const NPS_LEADER = "nps-leader"
export const ENPS_NPS_SCALE = "enps-nps-scale"
export const MULTIPLE_CHOICE = "multiple-choice"
export const SEGMENTS = "segment"
export const SUPPORT = "support"
export const CUSTOM_INDICATORS = "other-indicators"
export const COLUMN_LIST_COLLABORATORS = [
  {
    value: "email",
    description: "Correo",
  },
  {
    value: "division",
    description: "División",
  },
  {
    value: "segment",
    description: "Segmentos",
  },
  {
    value: "leader",
    description: "Líder",
  },
  {
    value: "team",
    description: "Equipo",
  },
  {
    value: "ambassador",
    description: "Embajador",
  },
  {
    value: "birthdate",
    description: "Fecha de nacimiento",
  },
  {
    value: "dni",
    description: "DNI",
  },
  {
    value: "up_category",
    description: "Categoría jerárquica",
  },
  {
    value: "geo_location",
    description: "Ubicación geográfica",
  },
  {
    value: "gender",
    description: "Género",
  },
]

export const MEASUREMENT_WIDGET_TYPE = {
  leadershipOrClimate: 1,
  enpsAndEngagement: 2,
  onlyEnps: 3,
  onlyEngagement: 4,
}

export const TYPE_SURVEY = {
  leadership: {
    idSurveyType: 2,
    slugSurveyType: "leadership",
    nameSurveyType: "Liderazgo",
  },
  engagement: {
    slugSurveyType: "engagement",
    nameSurveyType: "engagement",
  },
  climate: {
    idSurveyType: 1,
    slugSurveyType: "climate",
    nameSurveyType: "climate",
  },
  welfare: {
    idSurveyType: 3,
    slugSurveyType: "welfare",
    nameSurveyType: "Bienestar",
  },
  internalCustomer: {
    idSurveyType: 4,
    slugSurveyType: "internal_customer",
    nameSurveyType: "Cliente Interno",
  },
  culture: {
    idSurveyType: 5,
    slugSurveyType: "culture",
    nameSurveyType: "Cultura",
  },
  offboarding: {
    idSurveyType: 6,
    slugSurveyType: "offboarding",
    nameSurveyType: "Offboarding",
  },
  onboarding: {
    idSurveyType: 7,
    slugSurveyType: "onboarding",
    nameSurveyType: "Onboarding",
  },
}

export const TYPE_BENCHMARK = {
  isGlobal: 1,
  isIndustry: 2,
}

export const TYPE_QUESTION = {
  likert: 1,
  qualitative: 2,
  enps: 3,
  multiple_choice: 4,
}

export const PAGINATION_DEFAULT = {
  defaultPageSize: 10,
  pageSizeOptions: [10, 15, 25, 50, 100],
  showSizeChanger: true,
}

export const SCOPE_TYPE = {
  typeOrganization: 1,
  typeSegment: 2,
}

export const SURVEY_CALCULATION_TYPE = {
  topTwoBox: 1,
  average: 2,
}


export const SUPPORT_CHANNELS = {
  DEFAULT: "a2rhicul",
  PE: "a2rhicul",
  AR: "i320has1"
}